import { Home, CheckCircle } from "lucide-react";
import interiorImage from "@/assets/family-cooking-tamales.jpg";
import { useTranslation } from 'react-i18next';

export const Solutions = () => {
  const { t } = useTranslation();
  
  return (
    <section id="services" className="pt-6 pb-12 bg-background" aria-labelledby="solutions-heading">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <img
              src={interiorImage}
              alt="Happy family cooking tamales together in their temporary housing kitchen"
              className="rounded-lg shadow-lg w-full h-auto"
              width={628}
              height={458}
              loading="lazy"
            />
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <h2 id="solutions-heading" className="text-3xl text-foreground mb-8 font-sans font-normal md:text-xl">
              {t('solutions.solutionsForFamily')}
            </h2>

            {/* ALE Housing */}
            <div className="mb-8">
              <div className="flex items-center gap-3 mb-4">
                <Home className="w-6 h-6 text-primary" />
                <h3 className="text-2xl font-semibold text-foreground">{t('solutions.aleHousing')}</h3>
              </div>
              <p className="text-muted-foreground leading-relaxed">
                {t('solutions.aleDescription')}
              </p>
            </div>

            {/* Specific Requirements */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <CheckCircle className="w-6 h-6 text-primary" />
                <h3 className="text-2xl font-semibold text-foreground">{t('solutions.specificRequirements')}</h3>
              </div>
              <p className="text-muted-foreground leading-relaxed">
                {t('solutions.specificRequirementsDescription')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
